import clsx from 'clsx';
import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** 위 라벨(선택). */
  label?: string;
  /** 에러 메시지(선택). */
  error?: string;
}

/**
 * 표준 입력 — 라벨 + 보더 + 포커스 링.
 * `required` 를 주면 라벨에 `*` 를 함께 그린다(폼의 필수 표기가 한 곳에서 결정되도록 —
 * 표기를 호출부마다 손으로 붙이면 필수를 추가할 때 표시만 빠뜨린다).
 */
export function Input({ label, error, className, id, ...rest }: InputProps) {
  return (
    <label className="block">
      {label && (
        <span className="block mb-1 text-xs font-medium text-text-secondary">
          {label}
          {rest.required && <span className="text-danger"> *</span>}
        </span>
      )}
      <input
        id={id}
        className={clsx(
          'w-full px-3 py-2 text-sm rounded-md bg-surface',
          'border border-border-default focus:border-accent focus:outline-none focus:shadow-focus',
          'placeholder:text-text-disabled',
          error && 'border-danger',
          className,
        )}
        {...rest}
      />
      {error && <span className="block mt-1 text-xs text-danger">{error}</span>}
    </label>
  );
}
